// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3U-6Z","requiredAsterisk":"Info_requiredAsterisk__3C4Qf"};